import { memo } from "react";

import { Box, Icon, useTheme } from "@seneca/senekit";
import { KeyColorRole } from "@seneca/senekit/out/styles/colors/types";
import { Dimension } from "@seneca/senekit/out/types";

type Size = Extract<Dimension, "xsmall" | "small" | "medium">;

const sizes: {
  [key in Size]: string;
} = {
  xsmall: "1.5em",
  small: "2em",
  medium: "64px"
};

type Props = {
  loading?: boolean;
  size?: Size;
  tone?: KeyColorRole;
};

const LoadingSpinner = ({
  loading = true,
  size = "medium",
  tone = "neutral"
}: Props) => {
  const { icons } = useTheme();

  return (
    <Box
      position="relative"
      padding="xsmall"
      marginY="none"
      marginX="auto"
      width={sizes[size]}
      height={sizes[size]}
    >
      {loading && (
        <Icon
          iconName={icons.loader}
          accessibilityLabel="Loading"
          size="fill"
          tone={tone}
        />
      )}
    </Box>
  );
};

export default memo<Props>(LoadingSpinner);
